"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var StopIcon = function (_a) {
    var toolTip = _a.toolTip;
    return (react_1.default.createElement(Tooltip_1.default, { content: toolTip },
        react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.8 11.2H11.2V4.8H4.8V11.2ZM8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0Z", fill: "#FE505D" }))));
};
StopIcon.defaultProps = {
    toolTip: undefined,
};
exports.default = StopIcon;
